import type { ValueOf } from '@vy/utils';

export const CUSTOMERS_PAGE_CSV_HEADERS = Object.freeze({
  STATUS: 'Status',
  NAME: 'Customer',
  CURRENCY: 'Currency',
  EXTERNAL_ID: 'External ID',
  CONTRACTS_COUNT: 'Contracts Assigned',
  ACTIVE_CONTRACTS_COUNT: 'Active Contracts',
  BILLING_INTERVAL: 'Billing Interval',
  PLAN_DURATION: 'Duration',
  PARENT_CUSTOMER: 'Parent Customer',
  CREATED_AT: 'Created At',
  IS_CHILD_CUSTOMER: 'Is Child Customer',
  SUBSIDIARY: 'Subsidiary',
  ADDRESS: 'Address',
  COUNTRY: 'Country',
  STATE: 'State',
  CITY: 'City',
  POSTAL_CODE: 'Postal Code',
  PAYMENT_DUE_DAYS: 'Invoice Due Date',
  MANUAL_REVIEW: 'Manual Review - On/Off',
  TAX_ID: 'Tax ID',
  TAX_TYPE: 'Tax Type',
  WALLET: 'Wallet',
  ALIASES: 'Aliases',
});

export type CustomersPageCsvHeaders = ValueOf<typeof CUSTOMERS_PAGE_CSV_HEADERS>;
